import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { PureComponent } from "react";
import { componentStyles } from "./manage-options-component.scss";
import ManageOptionComponent from "./manage-option-component";
class ManageOptionsComponent extends PureComponent {
    renderOption(option) {
        const { onSelect, selectedOptions } = this.props;
        const isSelected = selectedOptions.indexOf(option) > -1;
        return /*#__PURE__*/ _jsx(ManageOptionComponent, {
            optionText: option,
            onSelect: onSelect,
            isSelected: isSelected
        }, option);
    }
    render() {
        const { options } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: `jsx-${componentStyles.__hash}` + " " + "manage-options-wrapper",
            children: [
                options.map((option)=>this.renderOption(option)),
                /*#__PURE__*/ _jsx(_JSXStyle, {
                    id: componentStyles.__hash,
                    children: componentStyles
                })
            ]
        });
    }
    constructor(props){
        super(props);
        this.renderOption = this.renderOption.bind(this);
    }
}
export { ManageOptionsComponent as default };
